// extracted by mini-css-extract-plugin
export default {"rating":"qA-z","numberOfStars":"rA-z","count":"sA-z","barGraphSpacing":"tA-z","barGraph":"uA-z"};